const CarBusinessTypeComponent = () => import('@/views/WareHouse/CarBusinessType/CarBusinessTypeView')

export default [
    {
        path:'/CarBusinessTypeIndex',
        name:'CarBusinessTypeComponent',
        component:CarBusinessTypeComponent
    }
]